<div class="text-center">
  <h2>A página que você tentou acessar não existe</h2>
  <p>
    Houve um erro inesperado, teste acessar a página inicial novamente
    https://des.cnbs.estaleiro.serpro.gov.br/cnbs-web/busca
  </p>
</div>
